import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { Target } from "@@/shared/target";
import type { UUID } from "@@/shared/uuid";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type InitiateSwishPaymentApiCommandResponse = {
    readonly _id: string;
    readonly _type: "SWISH_INITIATE_PAYMENT_API_COMMAND_RESPONSE";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly paymentUUID: UUID;
    readonly paymentToken?: string;
    readonly paymentFor: Target[];
};

type FactoryParams = Except<
    InitiateSwishPaymentApiCommandResponse,
    "_id" | "_createdAt" | "_type"
>;
const initiateSwishPaymentApiCommandResponseFactory = (
    params: FactoryParams,
): InitiateSwishPaymentApiCommandResponse => {
    return {
        _id: generateId({
            prefix: "swish_initiate_payment_api_command_response__",
        }),
        _createdAt: nowIsoAndUnix(),
        _type: "SWISH_INITIATE_PAYMENT_API_COMMAND_RESPONSE",
        ...params,
    };
};

const initiateSwishPaymentApiCommandResponseZodSchema: z.ZodSchema<InitiateSwishPaymentApiCommandResponse> =
    z.object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("SWISH_INITIATE_PAYMENT_API_COMMAND_RESPONSE"),
        paymentUUID: z.string() as unknown as z.ZodSchema<UUID>,
        paymentToken: z.string().optional(),
        paymentFor: z.array(z.string() as unknown as z.ZodSchema<Target>),
    });

export {
    initiateSwishPaymentApiCommandResponseFactory,
    initiateSwishPaymentApiCommandResponseZodSchema,
};
export type { InitiateSwishPaymentApiCommandResponse };
